module.exports = __webpack_public_path__ + "static/media/4041.e15aa5f7.png";